<div
  class="header-bar"
  style="display: flex; justify-content: space-between"
  xmlns="http://www.w3.org/1999/html"
>
  <h1>Route Algo Admin</h1>
</div>
<div class="">
  <div style="width: 100%">
    <p-tabView styleClass="route-algo-tabs" [(activeIndex)]="selectedTab">
      <p-tabPanel header="Supplier Access"
        ><app-route-algo-admin-organisation-manager></app-route-algo-admin-organisation-manager
      ></p-tabPanel>
    </p-tabView>
  </div>
</div>
